import React from 'react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="width site-footer__inner">
        <p>Built for calmer crypto tracking with caching, retries, and graceful provider fallbacks.</p>
        <a href="#top">Back to top</a>
      </div>
    </footer>
  );
}
